import { render, staticRenderFns } from "./UploadThumbnail.vue?vue&type=template&id=3dbfb764&scoped=true"
import script from "./UploadThumbnail.vue?vue&type=script&lang=js"
export * from "./UploadThumbnail.vue?vue&type=script&lang=js"
import style0 from "./UploadThumbnail.vue?vue&type=style&index=0&id=3dbfb764&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfb764",
  null
  
)

export default component.exports